import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "tick",
  "use": "tick-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"tick\"><title>6DF4F3DA-2171-471E-A1C5-72816A710E6B</title><path d=\"M4.693 13.178L1.414 9.899 0 11.314l3.934 3.934.656.656L15.904 4.59l-1.312-1.312-9.9 9.9z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol